const MetricsState = {
    summary: [],
    dashboard: {
        users: []
    },
    getBalances: {}
};

export default MetricsState;